import { UIIcon } from '../../config/icons';
import { chEventFilterPast, chEventListFilterActive, chEventListFilterFuture, chEventListFilterUpcoming, chEventListNextSessionTime, chEventListSessionTimeAfter, CHEventListView, chEventLocation } from '../mdl/c-event-home';
import { c_event_tags, CEventSortOrder, CEventTag, cEventTagName } from '../mdl/c-event-tag';
import { meSaveEvent, meUnsaveEvent } from '../mdl/c-user-home';
import { FEventCardShape, FEventListDisplay } from '../mdl/f-page-block';
import { hasActiveStatus, hasEventTags } from '../me/home';
import { the_user } from '../me/login';
import { UIAdapter, UIDataAdapter, UIViewAdapter } from '../ui/component/adapter';
import { UIButton } from '../ui/component/button';
import { UIImageView } from '../ui/component/image';
import { hLine } from '../ui/component/line';
import { UIList } from '../ui/component/list';
import { $composer } from '../ui/composer';
import { $el } from '../ui/elements';
import { uiSetScrollId } from '../ui/functions';
import { uiAddRipple } from '../ui/ripple';
import { uiSetTransition } from '../ui/transition';
import { UIClassesSpec } from '../ui/types';
import { UIView } from '../ui/view';
import { yGetI18N } from '../y/i18n';
import { $location } from '../y/location';
import { $time, YTime } from '../y/time';
import { YId } from '../y/types';
import { yShuffleInline } from '../y/util';
import { ABAvailabilityDots } from './widgets-home';

export type ABEventListFilter = 'past' | 'active' | 'picks' | 'videos' | 'search' | 'upcoming' | 'future';

function sortNextTime(a: CHEventListView, b: CHEventListView, from?: YTime) {
    const a_next = from ? chEventListSessionTimeAfter(a, from) : a.sessions[0]?.time;
    const b_next = from ? chEventListSessionTimeAfter(a, from) : b.sessions[0]?.time;
    if(!a_next)
        return b_next ? 1 : 0;
    else if(!b_next)
        return -1;
    return $time.compare($time(a_next), $time(b_next));
}

function sortPopular(a: CHEventListView, b: CHEventListView) {
    return b.popularity - a.popularity;
}

function sortLatest(a: CHEventListView, b: CHEventListView) {
    return $time.compare($time(b.published_at), $time(a.published_at));
}

export class ABLandingEventCard extends UIView {
    constructor(event: CHEventListView, shape: FEventCardShape, from?: YTime, _event_list_id?: string) {
        super('div', ['o-event-card k-' + shape]);

        const tags = event.event_tag_ids.map(id => c_event_tags.maybe(id)!).filter(g => g?.is_genre);
        const without_play = tags.filter(t => t.id != '017160ee-53e0-70bf-8050-f572a04e7cc9');
        const next_session = chEventListNextSessionTime(event, from);
        const is_loyalty = event.is_loyalty;

        const top = $el.DIV('r-top', $el.DIV('r-genre', [
            without_play.length ? without_play.slice(0, 2).map(g => $el.I(cEventTagName(g) + '\u00a0\u00a0\u00a0')) : $el.I('Övrigt'),
        ]));

        const picture = new UIImageView({ media: event.picture_id, variant: 'size-500' });

        const bottom = $el.DIV('r-bottom', [
            $el.DIV('r-title', yGetI18N(event.name)),
            hLine(),
            $el.DIV('r-dates', [
                $el.B(next_session ?? ''),
                $el.B(event.venue_name),
            ]),
        ])

        this.ui_add([
            top,
            picture,
            is_loyalty && $el.DIV('r-badge', $el.DIV('r-loyalty')),
            bottom
        ]);
    }
}

class ABEventCard extends UIView {
    constructor(event: CHEventListView, shape: FEventCardShape, flow: string, from?: YTime, event_list_id?: string) {
        super('div', ['tl-event-card k-' + shape]);

        const tags = event.event_tag_ids.map(id => c_event_tags.maybe(id)!).filter(g => g?.is_genre);
        const without_play = tags.filter(t => t.id != '017160ee-53e0-70bf-8050-f572a04e7cc9');
        const is_play = tags.length != without_play.length;
        const next_session = chEventListNextSessionTime(event, from);
        const is_loyalty = event.is_loyalty;

        const bottom = $el.DIV('r-bottom', $el.DIV('r-genre', [
            is_play ? $el.ICON(UIIcon.PLAY | UIIcon.WEIGHT_SOLID) : $el.DIV('tl-icon m-event'),
            without_play.length ? without_play.slice(0, 2).map(g => $el.I(cEventTagName(g) + '\u00a0\u00a0\u00a0')) : $el.I('Övrigt'),
        ]));

        if(!is_play) {
            const rating = event.rating_score;
            if(rating != null && rating > 0) {
                bottom.ui_add([
                    $el.S(),
                    $el.I([$el.ICON(UIIcon.THUMBS_UP | UIIcon.WEIGHT_SOLID), `\u00a0${(rating * 100).toFixed(0)}%`])
                ]);
            }
        }

        const picture = new UIImageView({ media: event.picture_id, variant: 'size-500' })

        this.root.addEventListener('click', () => {
            uiSetTransition('event-image', picture, 'src');
            uiSetTransition('event-info', texts, 'src');
            $location.navigate({ path: chEventLocation(event), params: { flow, event_list_id }, transition_params: { event_id: event.id } });
        });

        this.classList.add('tl-hover-zoom');
        uiAddRipple(this);

        const texts = $el.DIV('r-texts', [
            $el.DIV('r-top', [
                $el.I((next_session ? (next_session + ' • ') : '') + event.venue_name),
                $el.S(),
                hasActiveStatus() && event.sessions.some(s => s.is_bookable) && new ABAvailabilityDots(event.dots)
            ]),
            $el.DIV('r-title', yGetI18N(event.name)),
            bottom
        ])

        if($composer.current_transition) {
            const transition = $composer.current_transition;
            if(transition.event_id == event.id && (!transition.event_list_id || transition.event_list_id == event_list_id)) {
                uiSetTransition('event-image', picture, 'dst');
                uiSetTransition('event-info', texts, 'dst');
                this.classList.add('f-with-transition');
            }
        }

        this.ui_add([
            picture,
            is_loyalty && $el.DIV('r-badge', $el.DIV('r-loyalty')),
            texts
        ]);

        if(the_user) {
            //TODOURGENT: bring this back
            // meGetFriends().then(friends => {
            //     const fs = friends.byEvent(event.id);
            //     if(fs?.length)
            //         bottom.ui_add([$el.S(), new TLFriendsWidget(event, fs)]);
            // });

            let is_saved = the_user.saved_event_ids?.includes(event.id);
            const saved = new UIButton({
                icon: is_saved ? UIIcon.BOOKMARK | UIIcon.WEIGHT_SOLID : UIIcon.BOOKMARK, classes: 'r-saved m-extra-padding', on_click: () => {
                    is_saved = !is_saved;
                    saved.title = $el.ICON(is_saved ? UIIcon.BOOKMARK | UIIcon.WEIGHT_SOLID : UIIcon.BOOKMARK);
                    if(is_saved)
                        meSaveEvent(event.id);
                    else
                        meUnsaveEvent(event.id);
                }
            });

            this.ui_add(saved);
        }
    }
}

class ABImageCard extends UIView {
    constructor(image: YId) {
        super('div', 'tl-image-card tl-hover-zoom c-light', [
            new UIImageView({ media: image, variant: 'size-500' }, { classes: 'r-image' })
        ]);

        uiAddRipple(this);
    }
}

type ABEventListCustomFilter = (e: CHEventListView) => boolean;

interface ABEventListOptions {
    classes?: UIClassesSpec;
    filter?: ABEventListFilter;
    sort?: CEventSortOrder;
    randomize?: boolean;
    limit?: number;
    tag?: CEventTag;
    from?: YTime;
    id?: string;
    no_progressive?: boolean;
}

export class ABEventList extends UIView {
    empty_view?: (c: HTMLElement) => void;
    private _events: CHEventListView[];
    private _filter: ABEventListFilter | undefined;
    private _sort: CEventSortOrder;
    private _section!: UIDataAdapter<CHEventListView, ABEventCard>;
    private _city?: YId;
    private _limit?: number;
    private _randomize: boolean;
    private _from?: YTime;
    private _empty_view?: HTMLElement;
    private _custom_filter?: ABEventListCustomFilter;

    constructor(flow: string, display: FEventListDisplay, shape: FEventCardShape, events: CHEventListView[], options: ABEventListOptions = {}) {
        super('div', ['tl-event-list-container', options.classes, display == 'carousel' && 'l-h-scroll']);

        const event_list_id = options.id;

        if(event_list_id && (display == 'row' || display == 'carousel')) {
            uiSetScrollId(this, event_list_id);
        }

        const section = this._section = new UIDataAdapter<CHEventListView, ABEventCard>(e => new ABEventCard(e, shape, flow, this._from, event_list_id));
        const sections: UIAdapter[] = [section];
        if(options.tag) {
            const image = options.tag?.carousel_image;
            if(image) {
                const image_card = new ABImageCard(image);
                if(options.tag?.slug) {
                    image_card.ui_elem.addEventListener('click', () => {
                        uiSetTransition('tag-info', image_card, 'src');
                        $location.navigate(['genre', options.tag!.slug!]);
                    });

                    if($composer.current_transition?.tag_slug == options.tag.slug) {
                        uiSetTransition('tag-info', image_card, 'dst');
                        image_card.classList.add('f-with-transition');
                    }
                }
                sections.unshift(new UIViewAdapter(image_card));
            }
        }

        let limit = options.limit;

        if(display == 'row')
            limit = 3;
        else if(display == 'carousel' && !limit)
            limit = 12;

        this._limit = limit;
        this._events = events;
        this._from = options.from;
        this._randomize = !!options.randomize;
        this._filter = options.filter;
        this._sort = options.sort || 'date';

        const list = new UIList(sections, { classes: ['tl-event-list k-' + shape, display == 'carousel' && 'm-carousel', display == 'row' && 'm-row'], progressive: !limit && !options.no_progressive });

        this._doSearch();

        this.ui_add(list);
    }

    setMode(filter: ABEventListFilter, sort: CEventSortOrder) {
        this._filter = filter;
        this._sort = sort;
        this._doSearch();
    }

    set custom_filter(filter: ABEventListCustomFilter | undefined) {
        this._custom_filter = filter;
        this._doSearch();
    }

    set events(events: CHEventListView[]) {
        this._events = events;
        this._doSearch();
    }

    set city(city: YId | undefined) {
        this._city = city;
        this._doSearch();
    }

    set from(from: YTime | undefined) {
        this._from = from;
    }

    static filterEvents(events: CHEventListView[], filter: ABEventListFilter) {
        if(filter == 'past') {
            return events.filter(chEventFilterPast);
        } else if(filter == 'picks' && the_user) {
            return events.filter(e => chEventListFilterActive(e) && hasEventTags(e.event_tag_ids));
        } else if(filter == 'videos') {
            return events.filter(e => e.has_videos);
        } else if(filter == 'search') {
            return events.filter(e => e.has_videos || e.sessions.length);
        } else if(filter == 'future') {
            return events.filter(chEventListFilterFuture);
        } else if(filter == 'upcoming') {
            return events.filter(chEventListFilterUpcoming);
        } else if(filter == 'active') {
            return events.filter(chEventListFilterActive);
        }

        return events;
    }

    static sortEvents(events: CHEventListView[], sort: CEventSortOrder, from?: YTime) {
        if(sort == 'date') {
            if(from)
                events.sort((a, b) => sortNextTime(a, b, from));
            else
                events.sort(sortNextTime);
        } else if(sort == 'popular') {
            events.sort(sortPopular);
        } else { // 'latest'
            events.sort(sortLatest);
        }
    }

    private _doSearch() {
        let events = this._events;

        if(this._filter)
            events = ABEventList.filterEvents(events, this._filter);

        if(this._custom_filter)
            events = events.filter(this._custom_filter);

        if(this._city) {
            events = events.filter(e => e.city_id == this._city);
        }

        ABEventList.sortEvents(events, this._sort, this._from);

        if(this._limit) {
            events = events.slice(0, this._limit);
        }

        if(this._randomize) {
            yShuffleInline(events);
        }

        if(this._empty_view) {
            this._empty_view.remove();
            this._empty_view = undefined;
        }

        this._section.data = events;

        if(!events.length && this.empty_view) {
            const empty = this._empty_view = $el.DIV('tl-empty');
            this.empty_view(empty);
            this.ui_add(empty);
        }
    }
}
